import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@codex/themes';
import { Experiment, Variant } from '@dc/fo-experiment';
import { psaVariants }
  from '../components/react/PopupStyleAttach/components/PSAPopup/PSAPopup';
import TradeUp from '../components/react/TradeUp/components/TradeUp';
import { TRADEUP_AB_TEST_NAME, TRADEUP_AB_TEST_NAME_ON, TRADEUP_AB_TEST_NAME_OFF }
  from '../components/react/TradeUp/config/config';
import UISettings from '../utils/UISettings';
import translations from '../components/react/TradeUp/translations';

const React = require('react');
const ReactDOM = require('react-dom');

const initTradeUp = () => {
  const tradeUpSwitch = UISettings.get('component.tradeUp.enabled');
  const tradeUpWrapper = document.querySelector('[data-component="tradeup"]');
  const psaVariant = psaVariants[UISettings.get('component.psa.variant')];
  if (tradeUpWrapper) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ThemeProvider theme={themes.currys}>
          <Experiment
            experimentID={TRADEUP_AB_TEST_NAME}
            defaultVariantID={tradeUpSwitch ? TRADEUP_AB_TEST_NAME_ON : TRADEUP_AB_TEST_NAME_OFF}
          >
            <Variant variantID={TRADEUP_AB_TEST_NAME_ON}>
              <TradeUp title={translations.title} psaVariant={psaVariant} />
            </Variant>
            <Variant variantID={TRADEUP_AB_TEST_NAME_OFF}>
              <div />
            </Variant>
          </Experiment>
        </ThemeProvider>
      </Provider>,
      tradeUpWrapper
    );
  }
};

export default initTradeUp;
